import React from 'react'
import { motion } from 'framer-motion'
import heroprofile from '../../../assets/heroprofile.svg'

const HeroPortfolio = () => {
  const stats = [
    { number: '40+', label: 'App Development' },
    { number: '30+', label: 'Web Development' },
    { number: '100+', label: 'Happy Clients' },
    { number: '10+', label: 'Counters Serviced' },
  ]

  return (
    <div className='mx-auto relative'>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
        viewport={{ once: true }}
        className='relative z-10'
      >
        <div className="relative w-full -mt-4 overflow-hidden bg-white/5">

          {/* Image fills whatever height the content below defines */}
          <img
            src={heroprofile}
            alt="App Preview Mockup"
            className="absolute inset-0 w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%' }}
          />

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/40" />

          {/* Text content — now in normal flow, so it defines the height */}
          <div className="relative flex flex-col py-6 sm:py-10 md:py-12 lg:py-15 px-4 sm:px-8 md:px-14 lg:px-20">

            <p className="text-xs sm:text-base md:text-lg lg:text-xl leading-[150%] font-semibold text-[#4AC3D5]">
              Our Featured Work
            </p>

            <h1 className="text-white text-lg sm:text-2xl md:text-3xl lg:text-3xl font-bold mt-1 sm:mt-2 md:mt-3 lg:mt-3 leading-tight">
              Building Scalable Web & Mobile Solutions
            </h1>

            <p className='text-white/90 text-[11px] sm:text-sm md:text-sm lg:text-[15px] mt-2 sm:mt-2 md:mt-3 lg:mt-3 leading-relaxed'>
              Explore our portfolio of high-performance web applications and mobile platforms <br className="hidden md:block" /> designed with clean architecture and intuitive user experiences.
            </p>

            <div className="flex flex-wrap gap-x-3 sm:gap-x-8 md:gap-x-10 lg:gap-x-10 gap-y-2 mt-3 sm:mt-6 md:mt-8 lg:mt-11">
              {stats.map((stat, idx) => (
                <div key={idx}>
                  <p className="text-[#4AC3D5] text-base sm:text-2xl lg:text-3xl font-bold">
                    {stat.number}
                  </p>
                  <p className="text-white text-[10px] sm:text-xs lg:text-sm mt-1">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>

          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default HeroPortfolio